const constants = {
  APPLE_ONE_INDIVIDUAL: "R3556",
  APPLE_ONE_FAMILY: "R3557",
  APPLE_MUSIC_FAMILY: "R3555",
  APPLE_ONE_GROUP_IDS: ["R3556", "R3557"],
  NETMAX_PERK_ID: "R3559",
  UNLIMITED_CLOUD_STORAGE:["R3552","R3553"],
  UNLIMITED_CLOUD_INDIVIDUAL:"R3552",
  UNLIMITED_CLOUD_GROUP:"R3553",
  DONOTSHOW_PERK_TILE_GROUP:["R3553", "R3784", "R3557"],
  WALMART_PLUS_MEMBERSHIP:"R3554",
  NETFLIX_AND_MAX :"R3559",
  WHOLE_HOME_WIFI: "R1739",
  INTERNETROUTER_IDS:["R1767","R1739"],
  HOME_DEVICE_ADVISOR:"R3731",
  VERIZON_HOME_DEVICE_PROTECT:"R3784",
  PROTECT_GROUP_IDS: ["R3731", "R3784"],
  DISNEY_BUNDLE: 'R3558',
  DISNEY_TRIO: "R4438",
  YOUTUBE_PREMIUM: "R3680",
};

export const emberMnHPerkCreditOfferAttributes = {
  "R3551": "MF4PPLPKCR", // +play
  "R3552": "MF4UCIPKCR", // VZ Cloud Unlimited Individual
  "R3553": "MF4UCGPKCR", // VZ Cloud Unlimited Group
  "R3554": "MF4WALPKCR", // Walmart+
  "R3555": "MF4AMFPKCR", // Apple Music Family
  "R3556": "MF4AOIPKCR", // Apple One Individual
  "R3557": "MF4AOFPKCR", // Apple One Family
  "R3558": "MF4DIBPKCR", // Disney Bundle
  "R3559": "MF4NMXPKCR", // Netflix & Max
  "R3680": "MF4YTPPKCR", // Youtube Premium
  "R4224": "MF4GAIPKCR", // Google AI Premium
};

export default constants;
